module.exports = __webpack_public_path__ + "static/media/myAthina_Desktop.29cbc491.svg";